import { render } from "./TheFaqList.vue?vue&type=template&id=f24770da&scoped=true&ts=true&lang=html"
import script from "./TheFaqList.vue?vue&type=script&lang=ts"
export * from "./TheFaqList.vue?vue&type=script&lang=ts"

import "./TheFaqList.vue?vue&type=style&index=0&id=f24770da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f24770da"]])

export default __exports__